export default "__VITE_ASSET__afc8f837__"